import React, {useEffect} from 'react';
import Graph from "./components/graph.jsx";

function Demo() {

    return (
        <div>
            <Graph
                demo={true}
            />
        </div>
    );
}

export default Demo;
